import pickBy from 'lodash/pickBy'

export const authApi = {
  login: ({
    username,
    password,
    provider,
    countryCode,
    phone,
    email,
    dt,
    additionalUserInfo,
    loginType,
    isSignature,
    idToken,
    ac,
    nick_name,
    platform,
    fc,
  }) => ({
    url: 'v2/:clientId/login',
    method: 'post',
    params: {
      username,
      password,
      provider,
      countryCode,
      phone,
      email,
      dt,
      additionalUserInfo,
      loginType,
      isSignature,
      idToken,
      ac,
      nick_name,
      platform,
      fc,
    },
    isPublic: true,
  }),
  loginApp: ({ provider, accessToken, channel, subchannel, dt, from, id, name, picture }) => ({
    url: 'v2/:clientId/app-login',
    method: 'post',
    params: {
      provider,
      data: {
        accessToken,
        channel,
        subchannel,
        dt,
        from,
        id,
        name,
        picture,
        provider,
      },
    },
    isPublic: true,
  }),
  register: ({ channel, subchannel, ac, fc = null, dt, ...rest }) => {
    const traffic = pickBy({ channel, subchannel, ac, fc }, (value) => {
      return ![undefined, null, ''].includes(value)
    })

    const qs = new URLSearchParams(traffic).toString()

    const params = pickBy({ dt, ...rest }, (value) => {
      return ![undefined, null, ''].includes(value)
    })

    return {
      url: `v2/:clientId/register?${qs}`,
      method: 'post',
      params,
      isPublic: true,
    }
  },
  logout: () => ({ url: 'v2/:clientId/logout', method: 'post' }),
  // bindGet for 'google' | 'zalo' | 'facebook'
  bindGet: ({ x, provider, redirectURI }) => ({ url: 'v2/:clientId/bind', method: 'get', params: { x, provider, redirectURI } }),
  bindPost: ({ provider, countryCode, phone, email }) => ({
    url: 'v2/:clientId/bind',
    method: 'post',
    params: { provider, countryCode, phone, email },
  }),
  checkAccount: ({ account, nick_name, strategy, appSecret }) => ({
    url: 'v2/:clientId/check-account',
    method: 'post',
    params: { account, nick_name, strategy, appSecret },
    isPublic: true,
  }),
}
